<template>
  <div class="page">
    <div class="header">
      <button class="back-btn" @click="$router.back()">返回</button>
      <h2 class="header-title">小组管理</h2>
    </div>

    <!-- 滚动容器，header固定，内部内容滚动 -->
    <div class="scroll-wrap">
      <!-- 无小组空状态 -->
      <div v-if="!groupInfo" class="empty-box">
        <div class="empty-icon">👥</div>
        <p>你还没有加入/创建小组</p>
        <button class="create-btn" @click="showCreate = true">创建新小组</button>
      </div>

      <!-- 小组信息卡片 -->
      <div v-else class="group-card">
        <div class="group-title-row">
         <div class="title-left">
          <h3 class="group-name-title">小组名称：<span class="group-name-text">{{ groupInfo.groupName }}</span></h3>
          <span class="group-type-tag">{{ getTypeText(groupInfo.userType, groupInfo.subType) }}</span>
          </div>
          <div class="title-right">
          <button v-if="isGroupCreator" class="edit-group-btn" @click="openEditModal">小组命名</button>
          <button v-if="groupInfo" class="group-danger-btn" @click="isGroupCreator ? handleDissolve() : handleLeave()">
            {{ isGroupCreator ? '解散小组' : '退出小组' }}
          </button>
        </div>
      </div>
        <!-- 【已移除：小组ID整行】 -->

        <div v-if="isGroupCreator" class="invite-code-wrap">
          <div class="invite-header">
            <button class="invite-new-btn" @click="openInviteModal">+ 邀请组员加入</button>
            <span class="invite-hint">输入对方手机号，生成专属邀请码</span>
          </div>

          <div v-if="invitationList.length > 0" class="invite-list">
            <div v-for="inv in invitationList" :key="inv.id" class="invite-item">
              <span class="invite-phone">{{ inv.invitedPhone }}</span>
              <span class="invite-code-text">{{ inv.inviteCode }}</span>
              <span class="invite-status" :class="'status-' + inv.status">{{ statusText(inv.status) }}</span>
              <div class="invite-actions">
                <button v-if="inv.status === 'pending'" class="mini-btn" @click="copyCode(inv.inviteCode)">复制</button>
                <button v-if="inv.status === 'pending'" class="mini-btn danger" @click="revokeInvite(inv)">撤销</button>
              </div>
            </div>
          </div>
          <div v-else class="invite-empty">还没有邀请成员</div>

          <div v-if="copyTip" class="copy-tip">{{ copyTip }}</div>
        </div>

        <div class="section-card member-card">
          <div class="member-head">
            <h4>小组成员</h4>
          </div>
          <ul class="member-list">
            <!-- 改动：这里直接渲染 userId，不再读取name -->
            <li v-for="(member,idx) in groupInfo.memberList" :key="idx" class="member-item">
              <span class="member-name">{{ member.name || '未设置昵称' }} · {{ member.userId }}</span>
              <span v-if="isCreator(member)" class="creator-tag">创建人</span>
              <!-- 创建人可以移除其他成员，不能移除自己 -->
              <button
                v-if="isGroupCreator && !isCreator(member)"
                class="remove-member-btn"
                @click="handleRemoveMember(member)"
              >移除</button>
            </li>
          </ul>
        </div>

        <!-- ✅小组足迹记录：改为和个人足迹一致的双列卡片 -->
        <div class="section-card stat-card">
          <h4 class="section-title">小组足迹记录</h4>
          <div v-if="groupFootprintList.length === 0" class="empty-fp">
            <p class="empty-tip">该小组暂无足迹印记</p>
          </div>
          <div v-else class="footprint-grid">
            <div
              class="footprint-item"
              v-for="(item,idx) in showFootprintList"
              :key="idx"
              @click="$router.push({path:'/detail', query:{id: item.id}})"
            >
              <!-- 城市名称 + 到访次数放在同一行 -->
              <div class="city-row">
                <div class="city-name">{{ item.province }} · {{ item.city }}</div>
                <span class="visit-count">到访 {{ cityCountMap[item.city] || 1 }} 次</span>
              </div>
              <div class="time-text">
                {{ item.arriveTime }}
                <span v-if="item.leaveTime"> ~ {{ item.leaveTime }}</span>
              </div>
            </div>
          </div>
          <!-- 超过最大展示条数，显示更多按钮 -->
          <div v-if="groupFootprintList.length > maxShowCount" class="more-wrap">
            <button class="more-btn" @click="$router.push({path:'/footprintList', query:{groupId: groupInfo.groupId}})">更多</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 创建小组弹窗 -->
    <div v-if="showCreate" class="mask" @click.self="showCreate=false">
      <div class="modal">
        <h3>创建小组</h3>
        <div class="form-item">
          <label>小组名称</label>
          <input v-model="newGroup.groupName" type="text" placeholder="输入小组名称">
        </div>
        <div class="form-item">
          <label>使用人群类型</label>
          <select v-model="newGroup.userType">
            <option value="lover">恋人</option>
            <option value="family">亲子</option>
            <option value="elder">伴老</option>
            <option value="other">其他</option>
          </select>
        </div>
        <div class="btn-row">
          <button class="cancel-btn" @click="showCreate=false">取消</button>
          <button class="submit-btn" @click="createGroup">创建</button>
        </div>
      </div>
    </div>

    <!-- 编辑小组资料弹窗：只保留小组名称，移除人群类型 -->
    <div v-if="showEdit" class="mask" @click.self="showEdit=false">
      <div class="modal">
        <h3>小组命名</h3>
        <div class="form-item">
          <label>小组名称</label>
          <input v-model="editForm.groupName" type="text" placeholder="输入小组名称">
        </div>
        <!-- 已删除使用人群类型，编辑时不能修改 -->
        <div class="btn-row">
          <button class="cancel-btn" @click="showEdit=false">取消</button>
          <button class="submit-btn" @click="saveEdit">保存修改</button>
        </div>
      </div>
    </div>
     
          <!-- 邀请组员弹窗 -->
    <div v-if="showInviteModal" class="mask" @click.self="closeInviteModal">
      <div class="modal">
        <h3>邀请组员加入</h3>

        <div v-if="!generatedCode" class="form-item">
          <label>对方手机号</label>
          <input v-model="invitePhone" type="tel" maxlength="11" placeholder="输入11位手机号">
          <p class="modal-hint">对方必须用此手机号注册/登录后，才能用这个邀请码加入</p>
        </div>

        <div v-else class="generated-box">
          <div class="generated-label">邀请码（发给 {{ generatedPhone }}）：</div>
          <div class="generated-code">{{ generatedCode }}</div>
          <button class="copy-btn-big" @click="copyCode(generatedCode, true)">复制邀请码</button>
          <p class="generated-tip">邀请对方先注册/登录，再进入「个人中心 - 加入小组」输入此码即可。</p>
        </div>

        <div class="btn-row">
          <button class="cancel-btn" @click="closeInviteModal">关闭</button>
          <button v-if="!generatedCode" class="submit-btn" @click="doGenerateInvite">生成邀请码</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getGroupFootprintList } from '@/api/footprint.js'
export default {
  name: "GroupManage",
  data() {
    return {
      groupInfo: null,
      showCreate: false,
      showEdit: false,
      newGroup: {
        groupName: "",
        userType: "lover"
      },
      editForm: {
        groupName: "",
        // userType 移除，编辑不再操作该字段
      },
      copyTip: "",
      maxShowCount: 4, //最多展示4条足迹，可改为3/5
      groupFootprintList: [], // 【新增】独立存放小组足迹，不再挂在groupInfo上
      showInviteModal: false,
      invitePhone: '',
      generatedCode: '',
      generatedPhone: '',
      invitationList: []
    }
  },
  mounted() {
    this.loadGroupInfo()
  },
  watch: {
    // 监听路由id，切换小组自动重新加载数据，解决组件复用id不变bug
    '$route.query.id': {
      handler(newId) {
        if(newId) {
          this.loadGroupInfo()
        }
      },
      immediate: true
    }
  },
  computed: {
    isGroupCreator() {
      if (!this.groupInfo) return false
      const userStr = localStorage.getItem("currentUser")
      const user = JSON.parse(userStr || '{}')
      // ✅ 使用小组自带的 masterAccount 作为创建人判定，不再取memberList[0]
      return String(this.groupInfo.masterAccount) === String(user.phone)
    },
    // 截取前N条足迹，按时间倒序，最新的放最上面
    showFootprintList() {
      if (!this.groupFootprintList) return []
      const sortList = [...this.groupFootprintList].sort((a,b)=>{
        return new Date(b.createTime) - new Date(a.createTime)
      })
      return sortList.slice(0, this.maxShowCount)
    },
    // 城市到访次数统计（和个人足迹逻辑完全一样）
    cityCountMap() {
      const map = {}
      this.groupFootprintList.forEach(item => {
        if (!item.city) return
        if (!map[item.city]) {
          map[item.city] = 0
        }
        map[item.city]++
      })
      return map
    }
  },
  methods: {
    isCreator(member) {
      return String(this.groupInfo.masterAccount) === String(member.userId)
    },
    async loadGroupInfo() {
      const targetGid = this.$route.query.id
      if (!targetGid) return
      this.copyTip = ""
      this.groupFootprintList = []
      try {
        const res = await request.get('/group')
        if (!res.success) return
        const groupList = res.data || []
        this.groupInfo = groupList.find(g => g.groupId === targetGid)
        if (!this.groupInfo) return
        this.groupInfo.memberList = (this.groupInfo.memberList || []).filter(m => m && m.userId)
        const list = await getGroupFootprintList(targetGid)
        this.groupFootprintList = list
        this.loadInvitations()
      } catch (err) {
        console.error('获取小组信息失败', err)
        this.groupInfo = null
      }
    },
    getTypeText(type, otherSubType) {
      if (type === 'lover') return '恋人伴侣'
      if (type === 'family') return '亲子眷幼'
      if (type === 'elder') return '孝亲伴老'
      if (type === 'other') {
        if(otherSubType === 'colleague') return "同事"
        if(otherSubType === 'friend') return "朋友"
        if(otherSubType === 'relative') return "亲戚"
        if(otherSubType === 'classmate') return "同学"
        return "其他"
      }
      return type
    },
    // 打开邀请弹窗
    openInviteModal() {
      this.showInviteModal = true
      this.invitePhone = ''
      this.generatedCode = ''
      this.generatedPhone = ''
    },

    // 关闭邀请弹窗
    closeInviteModal() {
      this.showInviteModal = false
      this.invitePhone = ''
      this.generatedCode = ''
      this.generatedPhone = ''
    },

    // 生成邀请码
    async doGenerateInvite() {
      const phone = String(this.invitePhone || '').trim()
      if (!/^1\d{10}$/.test(phone)) {
        alert('请输入 11 位有效手机号')
        return
      }
      try {
        const res = await request.post('/group/invite', {
          groupId: this.groupInfo.groupId,
          invitedPhone: phone
        })
        if (!res.success) {
          alert(res.msg || '生成失败')
          return
        }
        this.generatedCode = res.data.inviteCode
        this.generatedPhone = res.data.invitedPhone
        this.loadInvitations()
      } catch (err) {
        console.error(err)
        alert('生成失败')
      }
    },

    // 加载邀请列表
    async loadInvitations() {
      if (!this.groupInfo) return
      try {
        const res = await request.get('/group/invitations', {
          params: { groupId: this.groupInfo.groupId }
        })
        if (res.success) {
          this.invitationList = res.data || []
        }
      } catch (err) {
        console.error('加载邀请列表失败', err)
        this.invitationList = []
      }
    },

        // 复制邀请码
    // closeAfter: 复制成功后是否自动关闭弹窗
    async copyCode(code, closeAfter = false) {
      try {
        await navigator.clipboard.writeText(code)
        this.copyTip = '✅ 邀请码已复制'
      } catch (err) {
        this.copyTip = '❌ 复制失败，请手动复制'
      }
      setTimeout(() => { this.copyTip = '' }, 2000)

      if (closeAfter) {
        // 留 500ms 让用户看清提示，再关闭弹窗
        setTimeout(() => {
          this.closeInviteModal()
        }, 500)
      }
    },

    // 撤销邀请
    async revokeInvite(inv) {
      const ok = await this.$showConfirm(`确定撤销对 ${inv.invitedPhone} 的邀请？`)
      if (!ok) return
      try {
        const res = await request.delete(`/group/invitation/${inv.id}`)
        if (res.success) {
          this.$showToast('已撤销', 'success')
          this.loadInvitations()
        } else {
          this.$showToast(res.msg || '撤销失败')
        }
      } catch (err) {
        console.error(err)
        this.$showToast('撤销失败')
      }
    },

    // 状态中文
    statusText(s) {
      if (s === 'pending') return '待接受'
      if (s === 'accepted') return '已加入'
      if (s === 'revoked') return '已撤销'
      return s
    },
    
    createGroup() {
      if (!this.newGroup.groupName.trim()) {
        alert("请填写小组名称")
        return
      }
      const groupList = JSON.parse(localStorage.getItem("groupList") || "[]")
      const userStr = localStorage.getItem("currentUser")
      const user = JSON.parse(userStr)
      const groupId = "g_" + Date.now()
      const inviteCode = Math.random().toString(36).slice(2,8).toUpperCase()
      const newGroupData = {
        groupId,
        inviteCode,
        groupName: this.newGroup.groupName.trim(),
        userType: this.newGroup.userType,
        subType: "",
        masterAccount: String(user.phone), // ✅ 存入创建人手机号，用于权限判断
        // =========修改：只保留userId，彻底移除name字段=========
        memberList: [{ userId: String(user.phone) }],
        // !!!重点：创建小组，不再内置footprintList数组，足迹独立在foot_record表
      }
      groupList.push(newGroupData)
      localStorage.setItem("groupList", JSON.stringify(groupList))

      alert("小组创建成功！")
      this.showCreate = false
      this.loadGroupInfo()
    },
    openEditModal() {
      // 只填充小组名称，不读取userType
      this.editForm.groupName = this.groupInfo.groupName
      this.showEdit = true
    },
        async saveEdit() {
      if (!this.editForm.groupName.trim()) {
        alert("小组名称不能为空")
        return
      }
      if (this.editForm.groupName.trim().length > 6) {
        alert("小组名称不能超过 6 个字！")
        return
      }
// ===== 敏感词校验 =====
      if (this.$hasSensitiveWord(this.editForm.groupName.trim())) {
        this.$showToast('小组名称包含违规词汇，请修改')
        return
      }

      try {
        const res = await request.put(`/group/${this.groupInfo.groupId}`, {
          groupName: this.editForm.groupName.trim()
        })
        if (res.success) {
          alert("小组资料修改成功！")
          this.showEdit = false
          this.loadGroupInfo()
        } else {
          alert(res.msg || '保存失败')
        }
      } catch (err) {
        console.error(err)
        alert('保存失败')
      }
    },
  async handleRemoveMember(member){
     const ok = await this.$showConfirm(`确定移除成员【${member.userId}】？移除后，该成员在小组内发布的足迹将移出小组而归属于发布者。`)
     if (!ok) return
      try {
        const res = await request.post(`/group/${this.groupInfo.groupId}/remove-member`, {
          targetPhone: member.userId
        })
        if (res.success) {
          alert(`成员【${member.userId}】已移除`)
          this.loadGroupInfo()
        } else {
          alert(res.msg || '移除失败')
        }
      } catch (err) {
        console.error(err)
        alert('移除失败')
      }
    },
        async handleDissolve() {
      const ok = await this.$showConfirm("确定要解散小组？小组关系及足迹会被清除！【所有足迹记录将分别归属至对应的登记者个人角色下】，此操作不可恢复！")
      if (!ok) return
      try {
        const res = await request.delete(`/group/${this.groupInfo.groupId}`)
        if (!res.success) {
          alert(res.msg || '解散失败')
          return
        }
        const userStr = localStorage.getItem("currentUser")
        const user = JSON.parse(userStr || '{}')
        if (Array.isArray(user.groupIdList)) {
          user.groupIdList = user.groupIdList.filter(id => id !== this.groupInfo.groupId)
        }
        if (user.groupId === this.groupInfo.groupId) {
          user.groupId = null
          user.groupType = null
        }
        localStorage.setItem("currentUser", JSON.stringify(user))
        alert("小组已解散！原小组足迹记录分配至提交人的足迹内。")
        this.$router.back()
      } catch (err) {
        console.error(err)
        alert('解散失败')
      }
    },
    async handleLeave() {
      const ok = await this.$showConfirm("确定退出该小组？退出后，你将无法查看该小组所有足迹。你提交到这个小组的足迹记录，只会保留在该小组内！如有需要，请下载后退出。")
      if (!ok) return
      try {
        const targetGid = this.groupInfo.groupId
        const res = await request.post(`/group/${targetGid}/leave`)
        if (!res.success) {
          alert(res.msg || '退出失败')
          return
        }
        const userStr = localStorage.getItem("currentUser")
        const user = JSON.parse(userStr || '{}')
        if (Array.isArray(user.groupIdList)) {
          user.groupIdList = user.groupIdList.filter(id => id !== targetGid)
        }
        if (user.groupId === targetGid) {
          user.groupId = null
          user.groupType = null
        }
        localStorage.setItem("currentUser", JSON.stringify(user))
        alert("退出小组成功")
        this.$router.back()
      } catch (err) {
        console.error(err)
        alert('退出失败')
      }
    }
  }
};
</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
}

/* ============================================================
   2. Header：高光玻璃导航（自适应排版）
   ============================================================ */
.header {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  padding: 0 clamp(16px, 3vw, 24px); 
  box-sizing: border-box;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.back-btn {
  border-radius: 6px; 
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px); 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}

.header-title {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  font-size: clamp(16px, 2.2vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

.group-danger-btn {
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(245, 108, 108, 0.85) !important;
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.5) !important;
  margin-left: 0; 
}
.edit-group-btn:hover,
.group-danger-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(245, 108, 108, 0.95) !important;
}

/* ============================================================
   3. 滚动区域与卡片容器（高光琉璃）
   ============================================================ */
.scroll-wrap {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: clamp(12px, 2vw, 20px);
  box-sizing: border-box;
}

.empty-box {
  margin-top: clamp(30px, 8vh, 60px);
  text-align: center;
}
.empty-icon { font-size: clamp(36px, 6vw, 50px); opacity: 0.6; margin-bottom: 12px; }
.empty-box p { color: #555; font-size: clamp(13px, 1.4vw, 16px); }
.create-btn {
  margin-top: 16px;
  padding: clamp(6px, 1vw, 10px) clamp(14px, 2vw, 20px);
  border-radius: 8px;
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  transition: all 0.2s ease;
}
.create-btn:hover { transform: translateY(-1px); }

.group-card {
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  padding: clamp(12px, 2vw, 20px);
}

.group-title-row {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.5vw, 15px);
  margin-bottom: clamp(10px, 2vh, 16px);
  flex-wrap: wrap;
}
.group-name-title {
  font-family: "SimHei", "黑体", sans-serif;
  font-weight: bold;
  font-size: clamp(14px, 1.5vw, 18px);
  color: #333;
  margin: 0;
}
.group-name-text { color: #F56c6c; }
.group-type-tag {
  background: rgba(236, 245, 255, 0.8);
  color: #409eff;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: clamp(11px, 1vw, 13px);
  border: 1px solid rgba(217, 236, 255, 0.8);
  flex-shrink: 0;
}
.edit-group-btn,
.group-danger-btn {
  font-size: clamp(12px, 1.2vw, 14px);
  padding: clamp(3px, 0.5vh, 5px) clamp(8px, 1vw, 12px);
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.3), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  transition: all 0.2s;
  white-space: nowrap;
}

/* 👇 核心修复：把“小组命名”的 margin-left:auto 删掉！ */
.edit-group-btn {
  margin-left: auto; 
}

/* ============================================================
   4. 内部区块（成员、足迹）
   ============================================================ */
.invite-code-wrap {
  background: rgba(240, 247, 255, 0.7);
  padding: clamp(10px, 1.5vw, 16px);
  border-radius: 12px;
  margin-bottom: clamp(12px, 2vh, 16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 统一信息区块卡片 */
.section-card {
  border-radius: 12px;
  padding: clamp(10px, 1.5vw, 16px);
  margin-bottom: clamp(12px, 2vh, 16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.4);
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.8);
}
.member-card { background: rgba(242, 243, 245, 0.6); }
.stat-card { background: rgba(240, 247, 255, 0.6); }

.section-title {
  font-size: clamp(13px, 1.4vw, 16px);
  color: #444;
  font-weight: 600;
  margin: 0 0 clamp(8px, 1.2vh, 12px) 0;
}
.member-head { margin-bottom: clamp(8px, 1.2vh, 12px); }
.member-head h4 { font-size: clamp(13px, 1.3vw, 15px); color: #444; margin: 0; font-weight: 600; }

/* 成员列表 */
.member-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: clamp(6px, 1vw, 10px);
}
.member-item {
  padding: clamp(4px, 0.8vh, 8px) clamp(8px, 1vw, 12px);
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  display: flex;
  gap: clamp(4px, 0.8vw, 8px);
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.9);
}
.member-name { font-size: clamp(11px, 1.1vw, 13px); }
/* 统一成员标签的尺寸 */
.creator-tag,
.remove-member-btn {
  /* 强制高度一致 */
  height: clamp(18px, 2.5vh, 22px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 clamp(4px, 0.6vw, 6px);
  border-radius: 4px;
  font-size: clamp(10px, 1vw, 12px);
  font-weight: 600;
  white-space: nowrap;
  line-height: 1;
}

.creator-tag {
  color: #fff;
  background: #409eff;
  font-family: "STXingkai", "KaiTi", serif;
}

.remove-member-btn {
  border: none;
  background: rgba(245, 108, 108, 0.85);
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}
.remove-member-btn:hover { background: #e64340; }

/* 足迹列表（自适应网格，复用个人足迹的卡片排版） */
.footprint-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 默认 3 列 */
  gap: clamp(8px, 1vw, 12px);
  margin-bottom: 12px;
}
@media (max-width: 900px) {
  .footprint-grid { grid-template-columns: repeat(2, 1fr); } /* 小屏 2 列 */
}
@media (max-width: 600px) {
  .footprint-grid { grid-template-columns: 1fr; } /* 极窄屏 1 列 */
}

.footprint-item {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  padding: clamp(6px, 1vw, 10px) clamp(8px, 1.2vw, 14px);
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  transition: all 0.2s ease;
}
.footprint-item:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
.city-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
}
.city-name {
  font-size: clamp(12px, 1.2vw, 15px);
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.visit-count {
  font-size: clamp(10px, 1vw, 12px);
  color: #409eff;
  background: rgba(236, 245, 255, 0.8);
  border: 1px solid rgba(217, 236, 255, 0.8);
  border-radius: 4px;
  padding: 2px clamp(6px, 0.8vw, 8px);
  flex-shrink: 0;
  font-weight: 600;
}
.time-text { font-size: clamp(10px, 1vw, 12px); color: #666; }

/* ============================================================
   5. 邀请列表模块
   ============================================================ */
.invite-header {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.5vw, 12px);
  margin-bottom: clamp(10px, 1.5vh, 14px);
  flex-wrap: wrap;
}
.invite-new-btn {
  padding: clamp(4px, 0.8vh, 8px) clamp(10px, 1.5vw, 16px);
  border-radius: 6px;
  cursor: pointer;
  font-size: clamp(12px, 1.2vw, 14px);
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  transition: all 0.2s;
}
.invite-new-btn:hover { transform: translateY(-1px); }
.invite-hint { font-size: clamp(10px, 1vw, 12px); color: #888; }

.invite-list {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vh, 8px);
}
.invite-item {
  display: flex;
  align-items: center;
  gap: clamp(6px, 1vw, 12px);
  padding: clamp(6px, 1vh, 10px) clamp(8px, 1.2vw, 12px);
  background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  flex-wrap: wrap; /* 允许小屏换行 */
}
.invite-phone { font-size: clamp(12px, 1.2vw, 14px); color: #333; }
.invite-code-text {
  font-family: monospace;
  font-size: clamp(13px, 1.3vw, 15px);
  color: #409eff;
  font-weight: bold;
}
.invite-status {
  font-size: clamp(10px, 1vw, 12px);
  padding: 2px clamp(6px, 0.8vw, 8px);
  border-radius: 4px;
  font-weight: 600;
}
.status-pending { background: rgba(255, 247, 230, 0.9); color: #e6a23c; }
.status-accepted { background: rgba(232, 247, 232, 0.9); color: #67c23a; }
.status-revoked { background: rgba(242, 242, 242, 0.9); color: #999; }

.invite-actions { margin-left: auto; display: flex; gap: clamp(4px, 0.8vw, 6px); }
.mini-btn {
  padding: 2px clamp(6px, 1vw, 10px);
  border: 1px solid #409eff;
  background: rgba(255, 255, 255, 0.8);
  color: #409eff;
  border-radius: 4px;
  cursor: pointer;
  font-size: clamp(10px, 1vw, 12px);
  transition: 0.2s;
}
.mini-btn:hover { background: #409eff; color: #fff; }
.mini-btn.danger { border-color: #f56c6c; color: #f56c6c; }
.mini-btn.danger:hover { background: #f56c6c; color: #fff; }
.invite-empty {
  text-align: center;
  color: #999;
  font-size: clamp(11px, 1.1vw, 13px);
  padding: 16px 0;
}

/* ============================================================
   6. 弹窗外壳（高光毛玻璃 + 紧凑自适应）
   ============================================================ */
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 16px; /* 防止弹窗贴边 */
  box-sizing: border-box;
}

.modal {
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  padding: clamp(16px, 2.5vw, 24px);
  border-radius: 16px;
  
  /* 宽度自适应：手机极窄 280，电脑最大 400 */
  width: clamp(280px, 85vw, 400px);
  /* 高度自适应：不超过屏幕 85% */
  max-height: 85vh;
  overflow-y: auto;
  
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  
  /* 隐藏滚动条 */
  scrollbar-width: none;
}
.modal::-webkit-scrollbar { display: none; }

/* 弹窗标题 */
.modal h3 {
  margin: 0 0 clamp(10px, 1.5vh, 16px) 0;
  text-align: center;
  color: #2c3e50;
  font-size: clamp(16px, 1.8vw, 19px);
  font-weight: 800;
  letter-spacing: 1px;
}

/* 表单项与输入框自适应 */
.form-item {
  margin: clamp(8px, 1.5vh, 14px) 0;
}
.form-item label {
  display: block;
  margin-bottom: clamp(4px, 0.8vh, 6px);
  color: #444;
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
}
.form-item input,
.form-item select {
  width: 100%;
  box-sizing: border-box;
  height: clamp(30px, 4.5vh, 38px);
  padding: 0 clamp(8px, 1.2vw, 12px);
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: clamp(12px, 1.2vw, 14px);
  transition: 0.2s;
}
.form-item input:focus,
.form-item select:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.modal-hint {
  font-size: clamp(10px, 1vw, 12px);
  color: #888;
  margin-top: 6px;
  margin-bottom: 0;
  line-height: 1.4;
}

/* ============================================================
   7. 弹窗底部按钮（高光琉璃）
   ============================================================ */
.btn-row {
  display: flex;
  gap: clamp(8px, 1.5vw, 12px);
  margin-top: clamp(16px, 3vh, 24px);
  justify-content: center; /* 居中更好看 */
}

.cancel-btn,
.submit-btn {
  padding: clamp(4px, 0.8vh, 6px) clamp(16px, 3vw, 24px);
  border-radius: 8px;
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  flex: 1; /* 两个按钮平分宽度 */
  max-width: 120px; /* 但不要太长 */
}

/* 取消按钮：灰色琉璃 */
.cancel-btn {
  background: linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,0.1)), rgba(144, 147, 153, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.6);
}
.cancel-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.5), rgba(255,255,255,0.2)), rgba(144, 147, 153, 0.95);
  transform: translateY(-1px);
}

/* 确认按钮：蓝色琉璃 */
.submit-btn {
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.submit-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.95);
  transform: translateY(-1px);
}
.cancel-btn:active,
.submit-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* ============================================================
   8. 邀请组员弹窗专属：生成结果框
   ============================================================ */
.generated-box {
  text-align: center;
  padding: clamp(12px, 2vw, 20px);
  background: rgba(240, 247, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  margin: clamp(10px, 1.5vh, 16px) 0;
  box-shadow: inset 0 1px 3px rgba(255,255,255,0.8);
}
.generated-label {
  font-size: clamp(12px, 1.2vw, 14px);
  color: #666;
  margin-bottom: 10px;
}
.generated-code {
  font-family: monospace;
  /* 字号超大，自适应 */
  font-size: clamp(24px, 4vw, 36px);
  letter-spacing: 4px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 12px;
  text-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
}
.copy-btn-big {
  padding: clamp(4px, 0.8vh, 8px) clamp(16px, 2vw, 24px);
  border-radius: 6px;
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 3px 8px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  transition: all 0.2s;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.copy-btn-big:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.95);
  transform: translateY(-1px);
}
.generated-tip {
  font-size: clamp(10px, 1vw, 12px);
  color: #888;
  margin-top: 12px;
  line-height: 1.5;
  margin-bottom: 0;
}
.title-left {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.5vw, 15px);
  flex-wrap: wrap; /* 名字长的时候自动换行 */
}

.title-right {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.5vw, 12px); /* 两个按钮之间的间距 */
  margin-left: auto; /* 👈 核心魔法：把右侧按钮组死死推到最右边 */
}
.empty-fp {
  text-align: center; /* 让文字居中更好看 */
  padding: clamp(16px, 3vh, 24px) 0;
}
.empty-tip {
  color: #999; /* 浅灰色，显得柔和 */
  font-size: clamp(12px, 1.2vw, 14px); /* 完美自适应：最小12px，最大14px */
  margin: 0;
}
</style>